"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _GridContainer = _interopRequireDefault(require("../../components/Grid/GridContainer/GridContainer"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _HorizontalDivider = _interopRequireDefault(require("../../elements/horizontal-divider/Horizontal-Divider"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _PageGrid = _interopRequireDefault(require("../../layouts/Skeletons/PageGrid/PageGrid"));
var _excluded = ["logoData"],
  _excluded2 = ["colOneContent", "colTwoContent", "colThreeContent"],
  _excluded3 = ["colOneContent", "colTwoContent"],
  _excluded4 = ["headingCopy", "subheadingCopy", "imageData"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var StyledThreeColumnLogo = (0, _styledComponents.default)(_Grid.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n\n  @media (min-width: ", ") {\n    margin-top: 15px !important;\n    margin-bottom: 15px !important;\n  }\n\n  @media (min-width: ", ") {\n  }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var StyledTwoColumnLogo = (0, _styledComponents.default)(_Grid.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n\n  @media (min-width: ", ") {\n    margin-top: 15px !important;\n    margin-bottom: 15px !important;\n  }\n\n  @media (min-width: ", ") {\n  }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    white: true,
    className: className
  }, " ", children, " ");
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    hsub: true,
    special: true,
    white: true,
    className: className
  }, " ", children, " ");
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledLogo = _styledComponents.default.img(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  max-width: 100%;\n  max-height: 150px;\n\n  @media (min-width: ", ") {\n  }\n\n  @media (min-width: ", ") {\n  }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var IndividualLogo = function IndividualLogo(_ref3) {
  var logoData = _ref3.logoData,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(_Link.default, {
    href: logoData.redirect
  }, _react.default.createElement(StyledLogo, {
    src: logoData.url,
    alt: logoData.name
  }));
};
var RowOne = function RowOne(_ref4) {
  var colOneContent = _ref4.colOneContent,
    colTwoContent = _ref4.colTwoContent,
    colThreeContent = _ref4.colThreeContent,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded2);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    item: true
  }, props), _react.default.createElement(StyledThreeColumnLogo, Object.assign({
    item: true,
    sm: 3,
    columnNumber: 'colOne'
  }, props), _react.default.createElement(IndividualLogo, Object.assign({
    logoData: colOneContent
  }, props))), _react.default.createElement(StyledThreeColumnLogo, Object.assign({
    item: true,
    sm: 5,
    columnNumber: 'colTwo'
  }, props), _react.default.createElement(IndividualLogo, Object.assign({
    logoData: colTwoContent
  }, props))), _react.default.createElement(StyledThreeColumnLogo, Object.assign({
    item: true,
    sm: 3,
    columnNumber: 'colThree'
  }, props), _react.default.createElement(IndividualLogo, Object.assign({
    logoData: colThreeContent
  }, props)))));
};
var RowThree = function RowThree(_ref5) {
  var colOneContent = _ref5.colOneContent,
    colTwoContent = _ref5.colTwoContent,
    props = (0, _objectWithoutProperties2.default)(_ref5, _excluded3);
  return _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    item: true
  }, props), _react.default.createElement(StyledTwoColumnLogo, Object.assign({
    item: true,
    columnNumber: 'colOne',
    sm: 5
  }, props), _react.default.createElement(IndividualLogo, Object.assign({
    logoData: colOneContent
  }, props))), _react.default.createElement(StyledTwoColumnLogo, Object.assign({
    item: true,
    columnNumber: 'colTwo',
    sm: 5
  }, props), _react.default.createElement(IndividualLogo, Object.assign({
    logoData: colTwoContent
  }, props))));
};
function cleanImageData(imageDataObject) {
  var dataArray = [];
  imageDataObject.map(function (item) {
    var itemHold = item.data;
    dataArray.push((0, _objectSpread2.default)({
      name: itemHold.file_name,
      redirect: itemHold.redirect_url,
      url: itemHold.aws_url
    }, itemHold.attachments[0]));
  });
  return dataArray;
}
var SupportersFunders = function SupportersFunders(_ref6) {
  var headingCopy = _ref6.headingCopy,
    subheadingCopy = _ref6.subheadingCopy,
    imageData = _ref6.imageData,
    props = (0, _objectWithoutProperties2.default)(_ref6, _excluded4);
  var cleanedData = cleanImageData(imageData);
  return _react.default.createElement(_PageGrid.default, Object.assign({
    heroBackgroundColor: 'var(--bf-core-teal)'
  }, props), _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    justifyContent: "center"
  }, props), _react.default.createElement(_Grid.default, {
    item: true
  }, _react.default.createElement(StyledSectionHeading, Object.assign({
    xs: 12
  }, props), headingCopy), _react.default.createElement(_HorizontalDivider.default, {
    dividerwhite: true
  }), _react.default.createElement(StyledSectionSubheading, props, subheadingCopy)), _react.default.createElement(RowOne, {
    justifyContent: "space-evenly",
    alignItems: "center",
    colOneContent: cleanedData[0],
    colTwoContent: cleanedData[1],
    colThreeContent: cleanedData[2]
  }), _react.default.createElement(RowOne, {
    justifyContent: "space-evenly",
    alignItems: "center",
    colOneContent: cleanedData[3],
    colTwoContent: cleanedData[4],
    colThreeContent: cleanedData[5]
  }), _react.default.createElement(RowThree, {
    justifyContent: "space-evenly",
    alignItems: "center",
    colOneContent: cleanedData[6],
    colTwoContent: cleanedData[7]
  })));
};
var _default = SupportersFunders;
exports.default = _default;